import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const courseCategoryApi = createApi({
    reducerPath: "courseCategoryApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["CourseCategory"],
    endpoints: (builder) => ({
        getAllCategory: builder.query({
            query: ({ pageno, search ,sortOrder, sortBy, limit}) => {
                let url = `/admin/course-categories?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (sortOrder) {
                    url += `&sortOrder=${sortOrder}`;
                }
                if (sortBy) {
                    url += `&sortBy=${sortBy}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["CourseCategory"],
        }),
        addCategory: builder.mutation({
            query: (data) => ({
                url: `/admin/course-category`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["CourseCategory"],
        }),
        updateCategory: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/course-category/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CourseCategory"],
        }),
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `/admin/course-category/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["CourseCategory"],
        }),
        getActiveCategory: builder.query({
            query: () => {
                let url = `/admin/active/course-category`;
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["CourseCategory"],
        }),
        getUserCourseCategories: builder.query({
            query: () => ({
                url: `/contractor/course/categories`,
                method: "GET",
            }),
            providesTags: ["CourseCategory"],
        }),
    }),
});

export const {
    useGetAllCategoryQuery,
    useAddCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
    useGetActiveCategoryQuery,
    useGetUserCourseCategoriesQuery,
} = courseCategoryApi;
